// @ts-nocheck


import { classesRuntime, statesRuntime } from "../../../stylable-esm-runtime.js";



var _namespace_ = "ValidationAndDefaultsSection738912025";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"ValidationAndDefaultsSection738912025__root","accordionWrapper":"ValidationAndDefaultsSection738912025__accordionWrapper"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-custom-modal-content-padding-horizontal":"--wds-custom-modal-content-padding-horizontal"}; 




